import React from 'react';
import {CompletionIconWrapper, FlagButton, FlagIcon, IconWrapper, ListItem, MoveBtn, NameContainer, NameText, getStyledIconByType} from './styles'
import {CompletionIcon, ProgressIcon} from "./helpers";
import {useTranslation} from "react-i18next";
import { useCustomSelector } from 'src/hooks/useCustomSelector';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Skill, SkillPart } from '@app-types/skill.types';
import { clearUserCourseLocationFlag, moveUserToCourseLevel, setUserCourseLocationFlag } from '@containers/Admin/containers/UserPage/actions';
import { Tooltip } from '@components/Tooltip';

interface BaseListItemProps {
    skill?: Skill
    resource?: SkillPart
    type: string
    isExpandable?: boolean,
    onExpand?: () => void,
    isFirstElement: boolean
    isCurrentLevel?: boolean
    isFlagged?: boolean
    isAvailable?: boolean
}

export const SkillsItem: React.FC<BaseListItemProps> =
    ({
        skill,
         resource,
         type,
         isExpandable,
         onExpand,
         isFirstElement,
        isCurrentLevel,
          isFlagged,
          isAvailable
     }) => {
        const {overview} = useCustomSelector('resourceManager');
        const TypeIcon = getStyledIconByType(type);
        const {t} = useTranslation();
        const {id:userId} = useParams<{ id: string }>();
        const dispatch = useDispatch();
        const hasFlaggedLocation = Boolean(overview?.resource?.flaggedCourseLocation?.entityId);
        const flagTooltip = isFlagged
            ? t('Actions.Navigation.removeFlag')
            : hasFlaggedLocation
                ? t('Actions.Navigation.moveFlagHere')
                : t('Actions.Navigation.addFlagHere');
        const moveHandler =():void=>{
            if (!resource) return;
            dispatch(moveUserToCourseLevel({
                userId,
                activityId: resource.id,
                activityType: resource.type,
            }));
        }
        const flagHandler = (): void => {
            if (!resource) return;
            if (isFlagged) {
                dispatch(clearUserCourseLocationFlag(userId));
            } else {
                dispatch(setUserCourseLocationFlag({
                    userId,
                    activityId: resource.id,
                    activityType: resource.type,
                }));
            }
        }
        return (
            <ListItem isFirstElement={isFirstElement}>
                {resource && !isFirstElement && (
                    <>
                        <IconWrapper><ProgressIcon isAccessible={Boolean(isAvailable)} isCurrent={Boolean(isCurrentLevel)} /></IconWrapper>
                        <CompletionIconWrapper isAvailable={isAvailable}>
                            <CompletionIcon hasPassed={resource.hasPassed} />
                        </CompletionIconWrapper>
                    </>
                )}
                <TypeIcon isCurrentLevel={isCurrentLevel}/>
                <NameContainer>
                    <NameText
                        isCurrentLevel={isCurrentLevel}
                        isExpandable={isExpandable}
                        onClick={isExpandable ? onExpand : () => {
                        }}
                    >
                        {resource ? resource.name : skill?.name}
                    </NameText>
                </NameContainer>
                <MoveBtn
                    onClick={moveHandler}
                    className='moveButton'
                    hideButton={isFirstElement||isCurrentLevel}
                >
                    {t('Actions.Navigation.moveHere')}
                </MoveBtn>
                {resource && !isFirstElement && (
                    <Tooltip content={flagTooltip} placement="top" hasArrow padding={8}>
                        <FlagButton
                            type="button"
                            className="courseLocationFlag"
                            onClick={flagHandler}
                            aria-label={flagTooltip}
                            isFlagged={isFlagged}
                        >
                            <FlagIcon />
                        </FlagButton>
                    </Tooltip>
                )}
            </ListItem>
        );
    };